import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=40f5a43c&scoped=true"
import script from "./Loading.vue?vue&type=script&lang=ts"
export * from "./Loading.vue?vue&type=script&lang=ts"
import style0 from "./Loading.scss?vue&type=style&index=0&id=40f5a43c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f5a43c",
  null
  
)

export default component.exports